module.exports = __webpack_public_path__ + "static/media/Uganda.f839a8c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/Uganda.jpg
// module id = 993
// module chunks = 0